jQuery(function () {
  Sparkle.DateField.replaceAll(document);
});
